import html2canvas from 'html2canvas';

export const logCanvas = async (canvas: HTMLCanvasElement) => {
    const thumbnailFile = await getCanvasFile(canvas, 'thumbnail');
    const reader = new FileReader();
    reader.onloadend = function () {
        const imageUrl = reader.result;
        console.log(
            '%c ',
            `font-size:400px; background:url(${imageUrl}) no-repeat; background-size: contain;`,
        );
    };
    reader.readAsDataURL(thumbnailFile);
};

type CanvasSize = {
    size: number;
    orientation?: 'landscape' | 'portrait';
};

export const resizeCanvas = (canvas: HTMLCanvasElement, ops: CanvasSize) => {
    const { size, orientation = 'landscape' } = ops;
    const aspectRatio = canvas.width / canvas.height;

    const tempCanvas = document.createElement('canvas');
    tempCanvas.width = orientation === 'landscape' ? size : size * aspectRatio;
    tempCanvas.height = orientation === 'landscape' ? size / aspectRatio : size;

    const tempCtx = tempCanvas.getContext('2d');
    tempCtx.drawImage(canvas, 0, 0, tempCanvas.width, tempCanvas.height);

    return tempCanvas;
};

export const getCanvasFile = async (
    canvas: HTMLCanvasElement,
    name = 'file',
) => {
    const blob = await new Promise<Blob | null>(resolve =>
        canvas.toBlob(resolve),
    );
    if (!blob) throw new Error('Failed to create the blob');

    const file = new File([blob], name + '.png', { type: 'image/png' });

    return file;
};

type HtmlToImageOptions = CanvasSize;

export const htmlToImage = async (
    element: HTMLElement,
    ops: HtmlToImageOptions,
) => {
    const { size, orientation } = ops;

    let canvas = await html2canvas(element, {
        useCORS: true,
        allowTaint: true,
        backgroundColor: null,
        scale: 1,
    });

    if (size) {
        canvas = resizeCanvas(canvas, { size, orientation });
    }

    logCanvas(canvas);

    const thumbnail = await getCanvasFile(canvas);

    return thumbnail;
};
